<template>
  <div>
    <p v-if="!isInternalSession" class="mx3 mt3 mb0 px2 h4 white-bg">Pour modifier vos coordonnées personnelles (prénom, nom, date de naissance, email), rendez-vous à l’accueil de votre centre.</p>
    <GenerateForm :form="form" :data="userModel" :save-action="submitForm"/>
  </div>
</template>

<script>
import { reactive, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

import GenerateForm from '@/components/common/GenerateForm';

import countries from '@/settings/countries.json'

import { updateUser } from '@/mixins/requests';
import { goBack, isInImpersonateModeNotification } from '@/mixins/utils';

import { useNotification } from '@kyvg/vue3-notification';

export default {
  components: { GenerateForm },
  setup () {
    const route = useRoute();
    const store = useStore();

    const userCountry = countries.find(c => c.value.toLowerCase() === store.state.user.country.toLowerCase() || c.text.toLowerCase() === store.state.user.country.toLowerCase())

    const userModel = reactive({ ...store.state.user, country: store.state.user.country && userCountry ? userCountry.value : store.state.user.country });

    const notification = useNotification();

    const isInternalSession = computed(() => store.state.siteInfo.is_internal_session)

    const form = reactive([
      [
        { label: 'Prénom', id: 'firstname', type: 'text', class: 'col-12 sm-col-6', required: true, placeholder: 'Votre prénom', disabled: !isInternalSession.value },
        { label: 'Nom', id: 'lastname', type: 'text', class: 'col-12 sm-col-6', required: true, placeholder: 'Votre nom', disabled: !isInternalSession.value }
      ],
      [
        { label: 'Date de naissance', id: 'birth_date', type: 'text', class: 'col-12 sm-col-6', required: true, placeholder: 'Ex: 27/03/1980', mask: '##/##/####', disabled: !isInternalSession.value },
        { label: 'Tél. mobile', id: 'mobilephone', type: 'tel', class: 'col-12 sm-col-6', required: false, placeholder: '' }
      ],
      [
        { label: 'Nº (rue, voie)', id: 'street_number', type: 'text', class: 'col-12 sm-col-6', required: false, placeholder: '' },
        { label: 'Nom de la voie', id: 'street_name', type: 'text', class: 'col-12 sm-col-6', required: false, placeholder: '' }
      ],
      [
        { label: "Complément d'adresse", id: 'address2', type: 'text', class: 'col-12 sm-col-6', required: false, placeholder: '' },
        { label: 'Code postal', id: 'zip_code', type: 'text', class: 'col-12 sm-col-6', required: false, placeholder: '' }
      ],
      [
        { label: 'Ville', id: 'town', type: 'text', class: 'col-12 sm-col-6', required: false, placeholder: '' },
        { label: 'Pays', id: 'country', type: 'select', class: 'col-12 sm-col-6', required: false, options: countries }
      ]
    ]);

    const submitForm = async () => {
      if (isInImpersonateModeNotification()) {
        return;
      }
      store.commit('setLoading', true);
      const user = await updateUser(userModel);

      const notificationData = {
        type: user.success ? 'success' : 'error',
        title: user.success ? 'L\'utilisateur a été mis à jour avec succès' : "Erreur lors de la mise à jour du client"
      }

      notification.notify(notificationData);

      if (user) {
        goBack(route);
      }
      store.commit('setLoading', false);
    };

    return {
      userModel,
      submitForm,
      form,
      isInternalSession
    };
  }
};
</script>

<style lang="scss" scoped>

</style>
